import { render, staticRenderFns } from "./ProductTileSizes.vue?vue&type=template&id=6e9706fa&"
import script from "./ProductTileSizes.vue?vue&type=script&lang=js&"
export * from "./ProductTileSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppInfoModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppInfoModal.vue').default})
